import type { RouteRecordRaw } from 'vue-router'

import { ensureRootRoutePath, type RedirectRoutePath } from '@/utilities/routers'

const routeSignName = '/sign'
const routeSignPath = ensureRootRoutePath(routeSignName)

const routeSign: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/SignView.vue')
  },
  meta: {
    requireAuth: false,
  },
  name: routeSignName,
  path: routeSignPath,
}

const redirectSign: RedirectRoutePath = {
  // use no "name" attribute here, not working with global navigationGuard
  path: routeSign.path,
}

export { redirectSign, routeSign }
